module.exports = __webpack_public_path__ + "img/yantian.fbc259c0.png";